<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="rachatDelaiCourt"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Rachat dans un délai court"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client demande le rachat d’un placement dans un délai court après l’investissement initial sans justification claire."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="periodeReflexionSoupcon"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Période réflexion avec soupçon"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Les circonstances dans lesquelles le client fait usage de la période de réflexion font naître un soupçon."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="achatVenteDelaiCourtSansStrategie"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Achat vente délai court sans stratégie"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client demande l’achat et la vente répétés d’actions dans un délai court, sans stratégie ni logique économique évidentes."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="fondsDestinationProvenanceTiers"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Fonds à destination ou provenance d’un tiers"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Les fonds proviennent ou sont à destination d’un compte qui n’est pas au nom du client."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="usageFaculteRenonciation"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Usage de la faculté de renonciation"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client fait un usage fréquent ou inattendu de la faculté de renonciation."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="rachatFrequentInexplique"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Rachat fréquent ou inexpliqué"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client effectue des rachats fréquents et inexpliqués ou procède à un rachat total de façon anticipée."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="demandeAvanceSansJustification"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Demande d’avance sans justification"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Demandes d'avances sans justification claire."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="transfertFrequentContrat"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Transfert fréquent de contrat"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Transferts fréquents du contrat d'un assureur à un autre."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="souscripteurDifferentPayeur"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Souscripteur ou adhérent différent du payeur"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le souscripteur ou adhérent est différent du payeur sans justification claire."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="ppeOuTiersSansLienDesigne"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="PPE ou tiers sans lien désigné"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Une PPE ou un tiers sans lien apparent avec le client nommément désigné bénéficiaire du contrat d'assurance vie."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="annulationSansJustificationAchatImmo"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Annulation sans justification achat immo"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Annulation subite et sans justification claire d'un achat immobilier."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="transactionMultipleSurPeriodeCourte"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Transaction immobilière multiple sur période courte"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Transactions immobilières multiples sur une courte période."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="achatImmoPrixSousOuSurEvalue"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Achat immo avec un prix très sous ou surévalué"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Transaction sur un bien immobilier à un prix manifestement sous-évalué ou surévalué."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="creditGarantieBienEtranger"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Crédit avec garantie sur un bien étranger"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Prêts garantis par la valeur de biens situés dans d’autres pays ou territoires, en particulier les pays ou territoires où il est difficile de déterminer si le client peut légitimement mettre en œuvre cette garantie, ou lorsque l’identité des parties garantissant le prêt est difficile à vérifier."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="operationComplexeMontantInhabituellementEleve"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Opération très complexe ou  montant inhabituellement élevé ou sans intérêt"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Opération particulièrement complexe ou d'un montant inhabituellement élevé ou ne paraissant pas avoir de justification économique ou d'objet licite (art. L561-10-2 du CMF)."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="operationFavoriseAnonymat"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Opération qui favorise l’anonymat"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Opération qui favorise l'anonymat du client ou du bénéficiaire effectif (art. L561-10 du CMF)."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="montantInadequationProfil"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Montant en inadéquation avec le profil"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Opération dont le montant n’est pas en rapport avec le montant des revenus ou du patrimoine."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="incoherenceOperationObjetSocialSociete"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Incohérence entre l’opération et l’objet social de la société"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Le client demande au cabinet de l’aider à obtenir un produit ou service d’un tiers sans logique économique ou commerciale claire."
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="paiementParBanqueHorsResidenceClient"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Paiement par banque hors résidence du client"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Paiements provenant de banques qui ne sont pas établies dans le pays de résidence du client."
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="produitServiceSansLogiqueSituationClient"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Produit ou service sans logique avec la situation du client"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Produit ou service sans logique avec la situation du client"
        />
      </div>
      <div class="col-xs-12 col-md-4 d-flex gap-1">
        <pr-input-radio
          formControlName="paiementNonIdentifiable"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Paiement non identifiable (chèque de banque)"
        >
        </pr-input-radio>
        <pr-tooltip-icon
          tooltip="Moyens de paiement dont l’identité du donneur d’ordre n’est pas précisée (chèque de banque)."
        />
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
